import { createAuthClient } from "better-auth/react";

const baseURL = 'https://api.dbdesign.io/';
// const baseURL = 'http://localhost:3003/';

export const authClient = createAuthClient({ baseURL });
